import * as React from 'react';
import { connect } from 'react-redux';
import * as agui from 'arm-gui/dist/controls';
import HomeActions from './HomeActions.js';
import { i18n } from 'arm-common';
import BoxInfo from './BoxInfo.jsx';
import DocumentiActions from '../documenti/DocumentiActions';
// import AmChartsPie from './AmChartsPie.jsx';

class Home extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = "[Home.jsx] ";
    }

    componentDidMount() {
        console.log(this.componentName + "componentDidMount");
        this.props.getPrintStatistiche();
    }

    render() {
        console.log(this.componentName + 'render');
        return (
            <div className="mt-3">
                <agui.aCard>

                    <agui.aCardHeader >
                        <h3 className="panel-title">{i18n('ARM_CORE_PRINT.HOME.WELCOME', 'Welcome')}, {this.props.utente.userId}</h3>
                    </agui.aCardHeader>

                    <agui.aCardBody>
                        <div className="w-100 ">
                            <div className="x_content  ">
                                <div className='row '>
                                    <BoxInfo boxOnClick={() => this.props.history.push('/documenti')} gruppo="dashboard" id="nr_documenti"
                                        numberVal={this.props.statistiche ? this.props.statistiche.nrDocumenti : null}
                                        headerText={i18n('ARM_CORE_PRINT.DASHBOARD.DOCUMENTI', 'Documenti')} pText={i18n('ARM_CORE_PRINT.DASHBOARD.NR_DOCUMENTI', 'Numero dei documenti')} icon="fas fa-solid fa-folder" />
                                    <BoxInfo boxOnClick={() => this.props.history.push('/dataSource')} gruppo="dashboard" id="nr_data_source"
                                        numberVal={this.props.statistiche ? this.props.statistiche.nrDataSource : null}
                                        headerText={i18n('ARM_CORE_PRINT.DASHBOARD.DATA_SOURCE', 'Data source')} pText={i18n('ARM_CORE_PRINT.DASHBOARD.NR_DATA_SOURCE', 'Numero delle data source')} icon="fas fa-solid fa-database" />
                                </div>

                            </div>
                        </div>
                    </agui.aCardBody>

                </agui.aCard>
            </div>
        );
    }
};

function mapDispatchToProps(dispatch) {
    return {
        getPrintStatistiche() {
            return dispatch(DocumentiActions.getPrintStatistiche());
        }
    }
};

function mapStateToProps(state) {
    return {
        utente: state.account.utente,
        statistiche: state.documentiReducer.statistiche
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Home);

